import React from 'react'
import NextLink, { type LinkProps } from 'next/link'

type ILinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
  LinkProps & {
    children?: React.ReactNode
  } & React.RefAttributes<HTMLAnchorElement>

export default function Link(props: ILinkProps) {
  const internalOnlyOnStudioGalleryOnClick = (event: MouseEvent) => {
    event.preventDefault()

    props?.onClick?.(event)

    window.alert(`Navigate pwa to ${props.href}`)
  }

  if (process.env.VITE_S4L_STUDIO) {
    // @ts-expect-error We dont care about these errors
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-has-content
    return <a data-testid="studio-link" {...props} onClick={internalOnlyOnStudioGalleryOnClick} />
  }

  return <NextLink legacyBehavior={false} {...props} />
}
